import { render, staticRenderFns } from "./review-changes-dialog.vue?vue&type=template&id=13e5bd39&scoped=true"
import script from "./review-changes-dialog.vue?vue&type=script&lang=js"
export * from "./review-changes-dialog.vue?vue&type=script&lang=js"
import style0 from "./review-changes-dialog.vue?vue&type=style&index=0&id=13e5bd39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5bd39",
  null
  
)

export default component.exports